import { WebRTC } from "../../libs/webRTC";
import { SignalingOfferResponse } from "../../proto/SignalingOffer_pb";
import BaseHandler from "../BaseHandler";

export default class HandleSignalingOfferResponse extends BaseHandler<SignalingOfferResponse> {
  handle() {
    const signalingOfferResponse = this.response.toObject();
    WebRTC.instance.onOffer(signalingOfferResponse.callerSdp, signalingOfferResponse.callerUserId, signalingOfferResponse.type).then();
  }
}
